/* RESPONSIBLE TEAM: team-frontend-tech */
import Model, { attr } from '@ember-data/model';

export default class AttributeOption extends Model {
  @attr('string') declare appId: string;
  @attr('string') declare identifier: string;
  @attr('string') declare value: string;
}
